<template>
  <el-dialog
    title="选择移动到"
    :visible.sync="selctedTableInfo.show"
    width="450px"
    :close-on-click-modal="false"
    @close="closeDia"
    destroy-on-close
  >
    <el-table
      :data="groupNameList"
      highlight-current-row
      headerRowClassName="RCTableHeader"
      cellClassName="RCTableCell"
    >
      <el-table-column label="" width="50">
        <template slot-scope="scope">
          <el-radio
            :label="scope.$index"
            v-model="radio"
            @change.native="getCurrentRow(scope.$index, scope.row)"
          >
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column property="className" label="班级名称">
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="sureMove" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    selctedTableInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
        };
      },
    },
    groupNameList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      radio: null,
      goalRow: {},
    };
  },
  methods: {
    closeDia() {
      this.$emit("closeDia");
    },
    getCurrentRow(index, row) {
      this.radio = index;
      this.goalRow = row;
    },
    sureMove() {
      this.$emit("sureMove", this.goalRow);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-radio__label {
  display: none;
}
</style>
